<app-auth-layout>
  <div class="container">
    <h1>{{title}}</h1>
    <span>{{message}}</span>
    <button type="button" (click)="onButtonClick()">{{buttonText}}</button>
  </div>
</app-auth-layout>

